function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M82.572 4.571v41.322a6.985 6.985 0 01-7.02 6.964H15.306a6.984 6.984 0 01-7.02-6.964V4.57H82.57z",
  fill: "#FDD840"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.279 52.857a6.983 6.983 0 003.955-1.764l-33.67-27.95-36.678 27.95a6.964 6.964 0 003.974 1.764h62.419z",
  fill: "#FCE477"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.286 4.571a6.797 6.797 0 001.653 2.656l30.587 23.047c3.993 2.935 6.017 2.935 9.935 0L80.92 7.227a6.798 6.798 0 001.653-2.656H8.285z",
  fill: "#FFCC07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.572 32.428h-1.858v1.858h1.857v-1.858zm3.714 0h-1.857v1.858h1.857v-1.858zm3.714 0h-1.857v1.858H25v-1.858zm3.714 0h-1.857v1.858h1.857v-1.858zM17.572 43.571h-1.858v1.858h1.857V43.57zm3.714 0h-1.857v1.858h1.857V43.57zm3.714 0h-1.857v1.858H25V43.57zm-7.428-3.714h-1.858v1.857h1.857v-1.857zm0-3.714h-1.858V38h1.857v-1.857zm11.142 3.714h-1.857v1.857h1.857v-1.857zm0-3.714h-1.857V38h1.857v-1.857zm0 7.428h-1.857v1.858h1.857V43.57z",
  fill: "#A99648"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.857 34.286h-9.286v9.285h9.286v-9.285z",
  fill: "#A99648"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 36.143h-5.571v5.571H25v-5.571z",
  fill: "#E0CA69"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.47 43.59H33.041v1.857H53.47V43.59zm0-3.714H33.041v1.857H53.47v-1.857z",
  fill: "#9C8A40"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.143 8.286v41.321a6.983 6.983 0 01-7.02 6.964H20.877a6.982 6.982 0 01-7.02-6.964V8.286h74.286z",
  fill: "#FDD840"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.85 56.572a6.983 6.983 0 003.956-1.765l-33.67-27.95-36.679 27.95a6.964 6.964 0 003.974 1.764H82.85z",
  fill: "#FCE477"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.857 8.286a6.797 6.797 0 001.653 2.655L46.097 33.99c3.993 2.934 6.017 2.934 9.936 0L86.49 10.94a6.796 6.796 0 001.653-2.655H13.857z",
  fill: "#FFCC07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.143 36.143h-1.857V38h1.857v-1.857zm3.714 0H25V38h1.857v-1.857zm3.714 0h-1.857V38h1.857v-1.857zm3.715 0h-1.857V38h1.857v-1.857zM23.143 47.286h-1.857v1.857h1.857v-1.857zm3.714 0H25v1.857h1.857v-1.857zm3.714 0h-1.857v1.857h1.857v-1.857zm-7.428-3.714h-1.857v1.857h1.857V43.57zm0-3.715h-1.857v1.857h1.857v-1.857zm11.143 3.715h-1.857v1.857h1.857V43.57zm0-3.715h-1.857v1.857h1.857v-1.857zm0 7.429h-1.857v1.857h1.857v-1.857zM32.428 38h-9.285v9.286h9.285V38z",
  fill: "#A99648"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.571 39.857H25v5.572h5.571v-5.572z",
  fill: "#E0CA69"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.041 47.304H38.613v1.857H59.04v-1.857zm0-3.714H38.613v1.857H59.04V43.59z",
  fill: "#9C8A40"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M94.531 37.796H68.067v26.241h26.464V37.796z",
  fill: "#F0F0F0"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M94.531 31.834H68.067v5.962h26.464v-5.962z",
  fill: "#4C3300"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M68.067 37.796h-4.011v26.241h4.011V37.796z",
  fill: "#CCCBCA"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M68.067 31.834h-4.011v5.962h4.011v-5.962z",
  fill: "#302100"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M94.531 37.796V59.06H72.376a4.308 4.308 0 01-4.309-4.346V37.796h26.465z",
  fill: "#fff"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M76.684 54.714a4.309 4.309 0 01-4.308 4.309H94.53a4.309 4.309 0 004.309-4.309H76.684z",
  fill: "#CCCBCA"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.224 32.726v.78a1.672 1.672 0 10-1.653-1.672h.706a.929.929 0 011.857 0 .893.893 0 01-.91.892zm4.03.78v-.001a1.67 1.67 0 10-1.727-1.67h.78a.929.929 0 011.857 0 .893.893 0 01-.91.89v.78a1.73 1.73 0 01-.056 0h.056zm4.03-.78v.78a1.672 1.672 0 10-1.671-1.672h.78a.89.89 0 01.891-.91.91.91 0 01.84 1.256.89.89 0 01-.84.546zm4.03.78v-.78a.892.892 0 00.91-.892.91.91 0 00-1.255-.84.891.891 0 00-.546.84h-.78a1.672 1.672 0 111.671 1.672zm4.03-.002v.002h-.074c.025 0 .05 0 .074-.002zm0 0v-.778a.874.874 0 00.892-.892.929.929 0 00-1.858 0h-.78a1.672 1.672 0 111.746 1.67zm4.03-.778v.78a1.69 1.69 0 001.672-1.672 1.671 1.671 0 10-3.343 0h.761a.91.91 0 011.256-.84.892.892 0 01.546.84.873.873 0 01-.892.892zm-20.15 9.211h8.692v8.692h-8.692v-8.692zm14.226 2.749h-2.358v-2.34h2.358v2.34zm2.693 0h-2.284v-2.34h2.284v2.34zm.464 0h2.359v-2.34h-2.359v2.34zm2.767.408h-.048l.048 2.767h-.048l.048 2.768H79.916v-8.692h11.403l.055 3.157zm-2.767 2.768v2.34h2.359v-2.34h-2.359zm-2.748 0h2.284v2.34h-2.284v-2.34zm-.409 0v2.34h-2.358v-2.34h2.358zm-5.107 0h2.34v2.34h-2.34v-2.34zm8.264-2.768v2.359h2.359v-2.359h-2.359zm-.464 2.359v-2.359h-2.284v2.359h2.284zm-2.693-2.359v2.359h-2.358v-2.359h2.358zm-2.767-2.748v2.34h-2.34v-2.34h2.34zm-2.34 5.107h2.34v-2.359h-2.34v2.359z",
  fill: "#685B47"
});
var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.4,
  y: 0.629,
  width: 86.114,
  height: 60.114,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -1.971,
  dy: 1.971
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.957
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 5.971,
  y: 4.343,
  width: 86.114,
  height: 60.114,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -1.971,
  dy: 1.971
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.957
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));
function SvgContactPolicyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPolicyIcon);
export default __webpack_public_path__ + "static/media/contact_policy_icon.201b2911901aa321c4feb48f594144fb.svg";
export { ForwardRef as ReactComponent };